import BaseModel from '../BaseModel';

export default class Discount extends BaseModel {
  static entity = 'discount';

  static primaryKey = 'id';

  static fields() {
    return {
      discount: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      async fetchDiscountInfo() {
        return this.get(`/referral/discount`)
      }
    },
  }
}